import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { useApiCampaignMember } from '@hooks-api/fortune/useApiCampaignMember'
import { useApiPartnerProfile } from '@hooks-api/fortune-fastpass/useApiPartnerProfile'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { VStack } from '@pets-ui/VStack/VStack'
import { type ReactNode, useEffect, useState } from 'react'

interface DialogPartnerAuthProps {
  onLogout?: () => void
  title?: ReactNode
  content?: ReactNode
}

export const DialogPartnerAuth = (props: DialogPartnerAuthProps) => {
  const { onLogout, title, content } = props
  const [showDialog, setShowDialog] = useState(false)
  const { campaignCodeFromUrl } = useCampaignCode()
  const { destructuredData: userInfo } = useApiCampaignMember({ code: campaignCodeFromUrl })
  const shouldNotAuthPartner = userInfo?.roles?.includes('shop_manager') || userInfo?.roles?.includes('administrator')
  const { error: partnerProfileError } = useApiPartnerProfile(shouldNotAuthPartner ? undefined : { code: campaignCodeFromUrl })

  const handleClickBack = () => {
    onLogout?.()
  }

  useEffect(() => {
    if (partnerProfileError?.status === 401) {
      setShowDialog(true)
    }
  }, [partnerProfileError])

  return (
    <Dialog
      open={showDialog}
    >
      <DialogContent>
        <VStack mt={4}>
          {title}
          {content}
        </VStack>
      </DialogContent>
      <DialogActions>
        <Button color="blue" onClick={handleClickBack}>返回登入頁</Button>
      </DialogActions>
    </Dialog>
  )
}
